export default (props, vars) => !!props?.['loading'];
